import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { type ReactNode, useMemo } from 'react'

import { BodyTypeTile } from '@/components/brp/BodyTypeTile'
import { BRPCarouselLayout } from '@/components/brp/BRPCarouselLayout'
import { TRANSLATION_KEYS } from '@/constants/localization'
import { getBrowseByBodyTypeData } from '@/features/search/utils/vertical-brp/getBrowseByBodyTypeData'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'

export const BodyTypeCarousel = () => {
  const { query } = useRouter()
  const { t } = useTranslation([TRANSLATION_KEYS.SRP])

  const data = useMemo(() => getBrowseByBodyTypeData(t, query), [t, query])

  const handleTileClick = (tileLabel: string) => {
    trackEvent({
      action: GA_EVENT.BRPCarouselClick,
      label: `page=brp_landing_page;section=browse_by_type;tile=${tileLabel}`,
    })
  }

  const slides: ReactNode[] = data.map((item) => {
    const { label, url, imgSrc } = item

    return (
      <BodyTypeTile
        key={label}
        label={label}
        url={url}
        imageSrc={imgSrc}
        onClick={handleTileClick}
      />
    )
  })

  return (
    <BRPCarouselLayout
      title={t('srp:search_by_body_type.carousel.title')}
      carouselName="browse-by-type"
      slides={slides}
      shouldShowArrows={false}
    />
  )
}
